import { render, staticRenderFns } from "./MenuItemListItem.vue?vue&type=template&id=51ad672b&scoped=true&"
import script from "./MenuItemListItem.vue?vue&type=script&lang=js&"
export * from "./MenuItemListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ad672b",
  null
  
)

export default component.exports